import Phaser from 'phaser';
import IceCreamData from '../IceCreamData';
import ABCyaPhaser from '@abcya/abcya_phaser';
import ItemSubMenu from './ItemSubMenu';
import FontKeys from '../FontKeys';

export default class ItemMenu extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene, menuActionHandler, itemActionHandler) {
    super(scene);

    this.menuActionHandler = menuActionHandler;
    this.itemActionHandler = itemActionHandler;

    this.currentMenu = 0;

    this.submenuContainer = this.scene.add.container();
    this.add(this.submenuContainer);

    /** @type {Phaser.GameObjects.Image[]} */
    this.buttons = [];

    /** @type {Phaser.GameObjects.Text[]} */
    this.buttonTexts = [];
    this.buttonContainer = this.scene.add.container();
    this.add(this.buttonContainer);
    const len = IceCreamData.menuData.length;
    let y = 0;
    let width = 0;
    for (let i = 0; i < len; i++) {
      const item = ABCyaPhaser.Images.addImage(0, y, `Menu+${IceCreamData.menuData[i].id}`, this.buttonContainer).setOrigin(0)
        .setInteractive();
      width = item.width;
      y += item.height;
      item.btnIndex = i;

      // add text
      let text = '';
      const position = { x: item.width / 2, y: 0 };
      const fontSize = 16;
      switch (i) {
        case 0:
          text = ABCyaPhaser.Localization.instance.getLocalizedString('game_screen.side_menu_labels.container');
          position.y = 124;
          break;
        case 1:
          text = ABCyaPhaser.Localization.instance.getLocalizedString('game_screen.side_menu_labels.flavor');
          position.y = 256;
          break;
        case 2:
          text = ABCyaPhaser.Localization.instance.getLocalizedString('game_screen.side_menu_labels.sauce');
          position.y = 404;
          break;
        case 3:
          text = ABCyaPhaser.Localization.instance.getLocalizedString('game_screen.side_menu_labels.whipped_cream');
          position.y = 550;
          break;
        case 4:
          text = ABCyaPhaser.Localization.instance.getLocalizedString('game_screen.side_menu_labels.toppings');
          position.y = 694;
          break;
      }
      const menuTxt = ABCyaPhaser.Text.addText(position.x, position.y, fontSize, 0xffffff, FontKeys._BPreplay, text, this.buttonContainer).setWordWrapWidth(75)
        .setResolution(1.5)
        .setLineSpacing(-2);
      this.buttonTexts.push(menuTxt);

      item.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.onMenuClick(item));
      this.buttons.push(item);

      if (i > 0) {
        item.setTint(0xBABABA).disableInteractive();
        menuTxt.setTint(0xBABABA);
      }
    }

    this.buttonWidth = width;

    this.activeSubmenu = new ItemSubMenu(this.scene, 5, this.onItemClick, this);
    this.activeSubmenu.setMenu(IceCreamData.menuData[0]);
    this.submenuContainer.add(this.activeSubmenu);
    this.activeSubmenu.setTweenPositions(this.buttonWidth);
    this.activeSubmenu.x = this.activeSubmenu.xCollapsed;
    this.activeSubmenu.visble = false;

    this.altSubmenu = new ItemSubMenu(this.scene, 5, this.onItemClick, this);
    this.altSubmenu.setMenu(IceCreamData.menuData[3]);
    this.altSubmenu.x = -this.scene.scale.width / 2;
    this.submenuContainer.add(this.altSubmenu);
    this.altSubmenu.setTweenPositions(this.buttonWidth);

    this.workingWidth = width;
    this.workingHeight = y;
  }

  enableFlavorsButton() {
    this.buttons[1].clearTint().setInteractive();
    this.buttonTexts[1].clearTint();

    this.buttons.forEach((button, index) => {
      if (index > 1) button.setTint(0xBABABA).disableInteractive();
    });
  }

  enableAllButtons() {
    this.buttons.forEach(button => button.clearTint().setInteractive());
    this.buttonTexts.forEach(text => text.clearTint());
  }

  onMenuClick (btn) {
    if (this.currentMenu === btn.btnIndex) {
      return;
    }

    this.menuActionHandler(btn.btnIndex);

    this.currentMenu = btn.btnIndex;
    const tmp = this.altSubmenu;
    this.altSubmenu = this.activeSubmenu;

    this.altSubmenu.collapseMenu();

    this.activeSubmenu = tmp;

    this.activeSubmenu.x = this.activeSubmenu.xCollapsed;

    this.activeSubmenu.setMenu(IceCreamData.menuData[this.currentMenu]);
    this.submenuContainer.add(this.activeSubmenu);

    this.activeSubmenu.extendMenu();

    if (this.currentMenu >= 2) {
      const cat = IceCreamData.menuData[this.currentMenu].category;
      this.activeSubmenu.selectMenuItem(0);
      this.itemActionHandler(cat, 1);
    }
  }

  onItemClick (item) {
    const cat = IceCreamData.menuData[this.currentMenu].category;
    const itemIndex = item.categoryItemIndex;
    this.activeSubmenu.selectMenuItem(itemIndex - 1);
    this.itemActionHandler(cat, itemIndex);
  }

  getHelperLocations () {
    const positions = [];
    let item = this.activeSubmenu.getAt(1);
    if (item) {
      const pos = ABCyaPhaser.GameObjects.getScreenPosition(item);
      positions.push(pos);
    }

    item = this.activeSubmenu.getAt(3);
    if (item) {
      const pos = ABCyaPhaser.GameObjects.getScreenPosition(item);
      positions.push(pos);
    }

    return positions;
  }

  reset () {
    this.buttons.forEach((button, index) => {
      if (index > 0) {
        button.setTint(0xBABABA).disableInteractive();
        this.buttonTexts[index].setTint(0xBABABA);
      }
    });
    if (this.currentMenu === 0) return;
    this.currentMenu = 0;
    const tmp = this.altSubmenu;
    this.altSubmenu = this.activeSubmenu;
    this.altSubmenu.collapseMenu();

    this.activeSubmenu = tmp;
    this.activeSubmenu.x = this.activeSubmenu.xCollapsed;
    this.activeSubmenu.setMenu(IceCreamData.menuData[this.currentMenu]);
    this.submenuContainer.add(this.activeSubmenu);
    this.activeSubmenu.extendMenu();
  }

  finishIntro () {
    this.activeSubmenu.visible = true;
    const time = 1000;
    this.activeSubmenu.extendMenu(time);
    return time;
  }
}